import { saveAs } from "file-saver";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaRegComment } from "react-icons/fa";
import { FiDownload } from "react-icons/fi";
import { PiEyeDuotone } from "react-icons/pi";
import { RiFileExcel2Line } from "react-icons/ri";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import swal from "sweetalert";
import {
  applyClassToCharacters,
  convertUTCToLocalTime,
  getStringFromJSX,
  isUrdu,
  LoadingSpinner,
} from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { ApiResponsibility } from "../../config/responsibilityType/ApiResponsibilityType";
import { GetLanguageString, NoResult } from "../../helper/Components";
import {
  GetCustomStyles,
  GetFooTableCustomStyles,
  GetPeriodName,
  GetSelectedLanguage,
} from "../../helper/Method";
import LFCFilter from "../../helper/SearchFilter/LFCFilter";
import SelectUnit from "../../shared/SelectUnit";
import AddLfcNotificationComment from "../AddLfcNotificationComment";
import { ApiNotifications } from "../ApiNotifications";
import { ApiLFC } from "../../letterForCounselling/ApiLFC";

const NotificationLFC = ({ activeTab, history }) => {
  const { t } = useTranslation();
  const [pagination, setPagination] = useState({ activePage: 1 });
  const [notificationTypes, setNotificationTypeFilter] = useState([]);
  const [commentModel, setCommentModel] = useState(false);
  const loggedInUnitId = encryptStorage.getItem("loggedInUnitId");
  const responsibilityName = encryptStorage.getItem("responsibilityName");
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);
  const [responsibilityList, setResponsibilityList] = useState([]);
  const [selectedType, setSelectedType] = useState({ value: 0, label: "All" });
  const responsibilityOptions = [];
  const [params, setParams] = useState({});
  const [id, setId] = useState(0);

  const [values, setValues] = useState({
    responsibilityIds: [],
    unit: { value: loggedInUnitId, label: "" },
    notificationTypeId: selectedType?.value,
    memberName: "",
    serialNumber: "",
    startDate: null,
    endDate: null,
    activePage: 1,
    creationDate: "neutral",
    includeSubUnit: true,
  });

  const setValuesWithPageReset = (newValues) => {
    setValues({ ...newValues, activePage: 1 });
    setPagination({ ...pagination, activePage: 1 });
  };

  const handleSubUnits = (e) => {
    const { value } = e.target;
    let v = value;
    if (value === "true") v = true;
    else v = false;
    setValuesWithPageReset({
      ...values,
      includeSubUnit: v,
    });
  };

  useEffect(() => {
    if (activeTab === "lfc") {
      ApiResponsibility()
        .getResponsibilitiesByLoggedInUnit(loggedInUnitId)
        .then((res) => {
          setResponsibilityList(res.data);
        })
        .catch((err) => console.log(err));

      ApiNotifications()
        .GetNotificationTypes(activeTab)
        .then((res) => {
          setNotificationTypeFilter(res.data);
        })
        .catch((err) => {
          swal({
            title: "Error: " + err.response?.data || err,
            icon: "error",
            buttons: "OK",
          });
          console.log(err.response.data);
          setLoading(false);
        });
    }
  }, [loggedInUnitId, activeTab]);

  responsibilityList.forEach((d) =>
    responsibilityOptions.push({ value: d.value, label: d.label })
  );

  const handlePageChange = (pageNumber) => {
    const updatedValues = {
      ...values,
      notificationTypeId: selectedType?.value,
      activePage: pageNumber,
      creationDate: "neutral",
    };
    setValues(updatedValues);
    setPagination({
      ...pagination,
      activePage: pageNumber,
    });
    fetchNotifications(updatedValues);
  };

  const handleChangeResponsibility = (record) => {
    if (record !== null && record.length > 0) {
      let responsibilityIds = [];

      // eslint-disable-next-line
      record.map((obj) => {
        responsibilityIds.push(obj.value);
      });

      if (responsibilityIds.length > 0) {
        setValuesWithPageReset({
          ...values,
          responsibilityIds: responsibilityIds,
        });
      }
    } else {
      setValuesWithPageReset({
        ...values,
        responsibilityIds: null,
      });
    }
  };

  const handleSorting = () => {
    if (
      values.creationDate === "neutral" ||
      values.creationDate === "descending"
    ) {
      setValues({
        ...values,
        creationDate: "ascending",
      });
    } else if (values.creationDate === "ascending") {
      setValues({
        ...values,
        creationDate: "descending",
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValuesWithPageReset({
      ...values,
      [name]: value,
    });
  };

  const handleSelectChangeNotificationType = (event) => {
    setSelectedType(event);
    setValuesWithPageReset(values);
  };

  const handleSubmit = () => {
    const updatedValues = { ...values, notificationTypeId: selectedType?.value };
    setValues(updatedValues);
    fetchNotifications(updatedValues);
  };

  const excelDownload = () => {
    setExcelLoading(true);
    ApiNotifications()
      .GenerateLfcNotificationsReport(values)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "NotificationLfcList.xlsx");

        setExcelLoading(false);
      })
      .catch((err) => {
        setExcelLoading(false);
        console.log(err);
      });
  };

  const fetchNotifications = (overrideValues) => {
    const params = overrideValues || values;
    setLoading(true);
    ApiNotifications()
      .GetLfcNotificationList(params)
      .then((res) => {
        const responseData = res?.data;
        if (
          !responseData ||
          !Array.isArray(responseData.notificationLfcList)
        ) {
          throw new Error("Invalid response format");
        }

        setPagination(responseData);
        setNotification(responseData.notificationLfcList);
        setLoading(false);
      })
      .catch((err) => {
        swal({
          title: "Error",
          text:
            err?.response?.data?.message || err.message || "Unknown error",
          icon: "error",
          buttons: "OK",
        });
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (activeTab === "lfc") {
      fetchNotifications();
    }
    // eslint-disable-next-line
  }, [activeTab]);

  const downloadLetter = (id, type, memberName) => {
    return new Promise((resolve, reject) => {
      const toastId = toast.loading(t("notifications_lfc_downloading"));

      ApiLFC()
        .LetterForCouncellingReportPDF(id)
        .then((res) => {
          const blob = new Blob([res.data], { type: "application/pdf" });
          saveAs(blob, `${type}-${memberName}.pdf`);

          toast.update(toastId, {
            render: getStringFromJSX(
              applyClassToCharacters(
                getStringFromJSX(
                  <GetLanguageString props={"notifications_lfc_downloaded"} />
                ),
                "ur"
              )
            ),
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
          resolve(true); // Resolve promise on success
        })
        .catch((err) => {
          console.error(`Error generating PDF: ${err}`);
          toast.update(toastId, {
            render: `Failed to download: ${err.message}`,
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
          reject(err); // Reject promise on error
        });
    });
  };

  let valuesIndex = pagination.pageSize * (pagination.activePage - 1) + 1;

  let pageInfo = `Displaying ${valuesIndex}-${
    valuesIndex + pagination.pageSize - 1 < pagination.totalItem
      ? valuesIndex + pagination.pageSize - 1
      : pagination.totalItem
  } of ${pagination.totalItem}`;

const shouldShowFeedback = (record, responsibilityName) => {
  const letterName = String(record?.letterName || "");
  const paramsForFeedback = record?.paramsJSON || {};

  const isMonthly = letterName.includes("ماہانہ");
  const isQuarterly = letterName.includes("سہ ماہی");
  const isHalfYearly = letterName.includes("ششماہی");

  const isNull = (v) => v === null || v === undefined;

  const responsibilityChecks = {
    "نقیب": () => isNull(paramsForFeedback.NaqeebFeedback) && isHalfYearly,

    "مقامی امیر": () =>
      isNull(paramsForFeedback.MuqamiAmeerFeedback) &&
      (isQuarterly || isHalfYearly),

    "امیر حلقہ": () =>
      isNull(paramsForFeedback.AmeerHalqaFeedback) &&
      (isMonthly || isQuarterly || isHalfYearly),

    "نائب ناظم اعلیٰ برائے زون": () =>
      isNull(paramsForFeedback.NaibNazimAllaFeedBack) &&
      (isMonthly || isQuarterly),

    "ناظم اعلیٰ": () =>
      isNull(paramsForFeedback.NazimAllaFeedBack) &&
      isMonthly &&
      record?.unitTypeName !== "Halqa",

    "امیر تنظیم اسلامی": () =>
      isNull(paramsForFeedback.AmeerMohtaramFeedBack) &&
      isMonthly &&
      record?.unitTypeName !== "Zone",
  };

  return responsibilityChecks[responsibilityName]?.() === true;
};

  return (
    <div>
      <ToastContainer
        autoClose={3000}
        bodyClassName={GetSelectedLanguage()}
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {commentModel && (
        <AddLfcNotificationComment
          params={params}
          notificationId={id}
          handleSubmitBack={handleSubmit}
          setCommentModel={setCommentModel}
        />
      )}
      <div className="panel panel-primary noprint">
        <div className="panel-heading">
          <h4>{<GetLanguageString props="common_search" />}</h4>
        </div>
        <div className="panel-body">
          <Row>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="member_search_by_name" />}
                </Label>
                <Input
                  className={isUrdu(values.memberName) ? "ur" : ""}
                  type="text"
                  name="memberName"
                  value={values.memberName}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="member_search_by_regno" />}
                </Label>
                <Input
                  type="text"
                  name="serialNumber"
                  value={values.serialNumber}
                  onChange={handleInputChange}
                />
              </FormGroup>
            </Col>
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="member_select_responsibility" />}
                </Label>
                <Select
                  options={responsibilityOptions}
                  className="basic-multi-select ur"
                  isMulti
                  placeholder={
                    GetSelectedLanguage() === "en" ? "Select" : "منتخب کریں"
                  }
                  isClearable
                  onChange={handleChangeResponsibility}
                />
              </FormGroup>
            </Col>{" "}
            <Col md="3">
              <FormGroup>
                <Label className="col-form-label">
                  {<GetLanguageString props="settings_notification_type" />}
                </Label>
                <Select
                  value={selectedType}
                  options={notificationTypes.map((notification) => ({
                    value: notification.id,
                    label: notification.name,
                  }))}
                  className="basic-single ur"
                  classNamePrefix="select"
                  isClearable={false}
                  onChange={handleSelectChangeNotificationType}
                />
              </FormGroup>
            </Col>
          </Row>
          <LFCFilter
            values={values}
            setValues={setValuesWithPageReset}
            showFullDate={true}
          />
          <Row>
            <SelectUnit
              unitId={loggedInUnitId}
              setValues={setValuesWithPageReset}
              values={values}
              excludeExUnit={true}
            />
            <Col md="4">
              <FormGroup check>
                <Label check for="subUnit">
                  <Input
                    id="subUnit"
                    type="checkbox"
                    name="includeSubUnit"
                    checked={values.includeSubUnit}
                    value={!values.includeSubUnit}
                    onChange={handleSubUnits}
                  />
                  {<GetLanguageString props="member_search_member_sub_unit" />}
                </Label>
              </FormGroup>
            </Col>
          </Row>{" "}
          <br></br>
          <br></br>
          <Row>
            <Col className="text-center">
              <ButtonGroup>
                <Button
                  color="primary"
                  className="m-l-sm"
                  type="submit"
                  onClick={handleSubmit}
                >
                  {<GetLanguageString props="common_search" />}
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </div>
      </div>
      <div className="panel panel-primary noprint">
        <div className="panel-heading">
          <h4>{<GetLanguageString props="notifications_lfc" />}</h4>
          {notification?.length !== 0 ? (
            <Button
              color="default"
              size="sm"
              style={{
                marginTop: -30,
              }}
              onClick={excelDownload}
              className={GetCustomStyles().btn_style}
            >
              {excelLoading ? (
                <Spinner size="sm" color="dark" />
              ) : (
                <>
                  <RiFileExcel2Line
                    size={15}
                    color="#009440"
                    style={{ marginRight: 3, marginBottom: 1 }}
                  />
                  <span style={{ color: "black" }}>
                    {<GetLanguageString props="member_report_export_excel" />}
                  </span>
                </>
              )}
            </Button>
          ) : null}
        </div>
        <div className="panel-body">
          {!loading ? (
            notification?.length !== 0 ? (
              <Table responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      {
                        <GetLanguageString props="settings_notification_type_name" />
                      }
                    </th>
                    <th>{<GetLanguageString props="common_name" />}</th>
                    <th>{<GetLanguageString props="member_reg_number" />}</th>
                    <th
                      className="cursor-pointer"
                      onClick={() => handleSorting("creationDate")}
                    >
                      {
                        <GetLanguageString props="member_member_detail_letter_for_counselling_received_date" />
                      }
                      <span className={GetFooTableCustomStyles().span_style}>
                        {values.creationDate === "neutral" ? (
                          <>
                            <i
                              className={
                                GetFooTableCustomStyles().up_down_style
                              }
                            />
                            <i
                              className={
                                GetFooTableCustomStyles().down_up_style
                              }
                            />
                          </>
                        ) : values.creationDate === "ascending" ? (
                          <i className={GetFooTableCustomStyles().up_style} />
                        ) : (
                          <i className={GetFooTableCustomStyles().down_style} />
                        )}
                      </span>
                    </th>
                    <th className="text-center">
                      {
                        <GetLanguageString props="member_member_detail_responsibility_history" />
                      }
                    </th>
                    <th className="text-center">
                      {
                        <GetLanguageString props="member_member_detail_unit_history" />
                      }
                    </th>
                    <th className="text-center">
                      {<GetLanguageString props="common_action" />}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {notification
                    ?.sort(function (a, b) {
                      if (a.startDate < b.startDate) return 1;
                      if (a.startDate > b.startDate) return -1;
                      return 0;
                    })
                    .map((record, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + valuesIndex}</td>
                          <td
                            className={
                              isUrdu(record.notificationTypeName) ? "ur" : ""
                            }
                          >
                            {record.notificationTypeName} &nbsp;&nbsp; (
                            {applyClassToCharacters(
                              GetPeriodName(
                                record.letterFrequency,
                                record.letterForFrequency
                              ) +
                                " " +
                                record.year,
                              "ur"
                            )}
                            )
                          </td>
                          <td className={isUrdu(record.memberName) ? "ur" : ""}>
                            {record.memberName}
                          </td>
                          <td>{record.regNo}</td>
                          <td>
                            {moment(
                              convertUTCToLocalTime(record.receivedAt)
                            ).format("DD/MM/yyyy")}
                          </td>

                          <td className="text-center">
                            {record.responsibilities.map((item, index) => {
                              return (
                                <Button
                                  size="xs"
                                  color="info"
                                  key={index}
                                  className="label label-info m-r-xs"
                                  disabled
                                >
                                  <h5 className="ur">{item}</h5>
                                </Button>
                              );
                            })}
                          </td>

                          <td className="text-center ur">{record.unitName}</td>
                          <td className="text-center">
                            {shouldShowFeedback(record, responsibilityName) ? (
                              // Render the button if any one condition above is true
                              <Button
                                color="white"
                                size="sm"
                                onClick={() => {
                                  setParams(record.paramsJSON);
                                  setId(record.id);
                                  setCommentModel(true);
                                }}
                              >
                                <FaRegComment
                                  color="#1ab996ff"
                                  size={15}
                                  className={GetCustomStyles().fa_style}
                                />
                                <GetLanguageString props="add_comment" />
                              </Button>
                            ) : null}
                            {"   "}
                            <Button
                              color="white"
                              size="sm"
                              onClick={() => {
                                history.push({
                                  pathname: `/member/viewLetterForCounselling/${record.memberId}`,
                                  state: {
                                    memberId: record.memberId,
                                    letterForCounselling: record.letterName,
                                    receivedLetterForCounsellingId:
                                      record.receivedLetterForCounsellingId,
                                    memberValues: {
                                      memberName: record.memberName,
                                      memberResponsibility:
                                        record.responsibilities[0],
                                      memberRegNo: record.regNo,
                                      memberUnit: record.unitName,
                                      memberUnitType: record.unitTypeName,
                                    },
                                    letterFrequency: record.letterFrequency,
                                    letterForFrequency:
                                      record.letterForFrequency,
                                    letterYear: record.year,
                                    receivedAt: record.receivedAt,
                                    commentsData: record.paramsJSON,
                                    calledAs: "lfc",
                                  },
                                });
                              }}
                            >
                              <PiEyeDuotone
                                color="#1A7BB9"
                                size={15}
                                className={GetCustomStyles().fa_style}
                              />
                              <GetLanguageString props="member_view" />
                            </Button>{" "}
                            <Button
                              color="white"
                              size="sm"
                              onClick={() =>
                                downloadLetter(
                                  record.id,
                                  record.notificationTypeName,
                                  record.memberName
                                )
                              }
                            >
                              <FiDownload size={16} color="#34A29E" />{" "}
                              <GetLanguageString props="notifications_lfc_download" />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
                <tr>
                  <td colSpan="6">{pageInfo}</td>
                  <td colSpan="7">
                    <ul className={GetCustomStyles().page_style}>
                      <Pagination
                        activePage={pagination.activePage}
                        itemsCountPerPage={pagination.pageSize}
                        totalItemsCount={pagination.totalItem}
                        pageRangeDisplayed={pagination.pageRange}
                        onChange={handlePageChange}
                      />
                    </ul>
                  </td>
                </tr>
              </Table>
            ) : (
              <NoResult />
            )
          ) : (
            LoadingSpinner()
          )}
        </div>
      </div>
    </div>
  );
};
export default withRouter(NotificationLFC);
